module.exports = __webpack_public_path__ + "static/img/teamDataTopCardBg.9349782.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invite/teamDataTopCardBg.png
// module id = El0W
// module chunks = 0